import { useState, useCallback } from 'react';
import { useAnnotationLibrary, AnnotationLibraryItem } from '../contexts/annotation-library.context';
import { AnnotationService } from '../../plan/services/annotation.service';
import { AnnotationModel } from '../../plan/models/annotation.model';
import { useUserContext } from '../../user/contexts/user.context';

export const useAnnotationAutocomplete = () => {
  const { searchAnnotations } = useAnnotationLibrary();
  const { getCurrentOrganization } = useUserContext();
  const [suggestions, setSuggestions] = useState<AnnotationLibraryItem[]>([]);
  const [isLoadingAnnotation, setIsLoadingAnnotation] = useState(false);

  const getSuggestions = useCallback((query: string) => {
    if (query.length >= 2) {
      const results = searchAnnotations(query);
      setSuggestions(results);
    } else {
      setSuggestions([]);
    }
  }, [searchAnnotations]);

  const loadAnnotationById = useCallback(async (annotationId: string): Promise<AnnotationModel | null> => {
    const orgaId = getCurrentOrganization()?.code;
    if (!orgaId) {
      return null;
    }

    setIsLoadingAnnotation(true);
    try {
      const annotation = await AnnotationService.getAnnotationById(orgaId, annotationId);
      return annotation;
    } catch (error) {
      console.error('Erreur lors du chargement de l\'annotation:', error);
      return null;
    } finally {
      setIsLoadingAnnotation(false);
    }
  }, [getCurrentOrganization]);

  const clearSuggestions = useCallback(() => {
    setSuggestions([]);
  }, []);

  return {
    suggestions,
    getSuggestions,
    loadAnnotationById,
    clearSuggestions,
    isLoadingAnnotation,
  };
};

